import { ReactNode, Ref, forwardRef } from 'react';
import styles from './StickyFilterHeader.module.scss';

type StickyFilterHeaderProps = {
    children: ReactNode;
};

export const StickyFilterHeader = forwardRef(function StickyFilterHeader(
    { children }: StickyFilterHeaderProps,
    ref: Ref<HTMLDivElement>,
) {
    return (
        <div ref={ref} className={styles.stickyFilterHeader}>
            {children}
        </div>
    );
});
